<template>
  <aside class="n5-lateral" :class="{ 'n5-lateral--abierto': abierto }" v-if="NOTARIA?.Theme">
    <div class="n5-lateral__barra">
      <NuxtLink :to="getLocalePath('/')" class="n5-marca">
        <img v-if="T.Menu?.Logo" :src="imagenIDtoSRC(T.Menu.Logo)" :alt="'Logo ' + NOTARIA.Nombre" />
        <span>{{ NOTARIA.Nombre }}</span>
      </NuxtLink>
      <div class="n5-lateral__acciones">
        <button v-if="NOTARIA.Personalizar?.Accesibilidad" type="button" class="n5-icono" @click="store.toggleModoAccesible"
          :aria-label="$t(store.ModoAccesible ? 'DesactivarModoAccesibilidad' : 'ActivarModoAccesibilidad')">
          <v-icon>mdi-human</v-icon>
        </button>
        <v-menu v-if="NOTARIA.Personalizar?.Multilenguaje && idiomas.length > 1">
          <template v-slot:activator="{ props }">
            <button type="button" class="n5-icono" v-bind="props" :aria-label="$t('seleccionIdioma')">
              <IconoIdioma :flag="store.getFlag" />
            </button>
          </template>
          <v-list density="compact">
            <v-list-item v-for="i in idiomas" :key="i.Language" @click="cambiarIdioma(i)" :title="i.Title">
              <template v-slot:prepend><IconoIdioma :flag="i.Flag" class="mr-2" /></template>
            </v-list-item>
          </v-list>
        </v-menu>
        <a v-if="C.Telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')" class="n5-icono n5-solo-movil" :aria-label="tSolicitud('Llamar')">
          <v-icon>mdi-phone-outline</v-icon>
        </a>
        <button type="button" class="n5-icono n5-solo-movil" :aria-expanded="abierto" aria-controls="n5-cuerpo" aria-label="Menú" @click="abierto = !abierto">
          <v-icon>{{ abierto ? 'mdi-close' : 'mdi-menu' }}</v-icon>
        </button>
      </div>
    </div>

    <!-- En escritorio, siempre a la vista; en móvil, al abrir el menú -->
    <div id="n5-cuerpo" class="n5-lateral__cuerpo">
      <nav class="n5-menu" :aria-label="$t('Inicio')">
        <template v-for="e in enlaces" :key="e.clave">
          <a v-if="e.externo" :href="e.href" target="_blank" rel="noopener">{{ e.texto }}</a>
          <NuxtLink v-else :to="e.to">{{ e.texto }}</NuxtLink>
        </template>
      </nav>

      <div class="n5-contacto">
        <span v-if="estado !== null" class="n2-estado" :class="estado ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
          <span class="n2-estado__punto"></span>{{ tSolicitud(estado ? 'Abierto ahora' : 'Cerrado ahora') }}
        </span>
        <a v-if="C.Telefono" class="n5-contacto__telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')">{{ C.Telefono.trim() }}</a>
        <a v-if="C.Direccion" class="n5-contacto__dato" :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">
          <v-icon size="18">mdi-map-marker-outline</v-icon>
          <span>{{ C.Direccion }}<br>{{ [C.CP, C.Municipio].filter(Boolean).join(' ') }}</span>
        </a>
        <a v-if="C.Email" class="n5-contacto__dato" :href="'mailto:' + C.Email">
          <v-icon size="18">mdi-email-outline</v-icon><span>{{ C.Email }}</span>
        </a>
        <NuxtLink v-if="acceso.visible('menu')" :to="acceso.enlace('menu')" class="n2-boton n2-boton--acento">{{ tSolicitud('Encargo online') }}</NuxtLink>
        <NuxtLink v-else-if="T.Menu?.ShowContacto" :to="getLocalePath('/contacto')" class="n2-boton n2-boton--acento">{{ tituloSeccion(NOTARIA, 'Contacto', $t) }}</NuxtLink>
      </div>
    </div>
  </aside>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { useMenuNotaria, abiertoAhora, tituloSeccion } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()
const route = useRoute()
const { enlaces, idiomas, cambiarIdioma } = useMenuNotaria()

const T = computed(() => NOTARIA.value?.Theme ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const abierto = ref(false)
// Depende de la hora del visitante: solo en el navegador
const estado = ref(null)

watch(() => route.fullPath, () => { abierto.value = false })
watch(abierto, (v) => { if (typeof document !== 'undefined') document.documentElement.style.overflow = v ? 'hidden' : '' })
onMounted(() => { estado.value = abiertoAhora(C.value.HorarioEstructurado) })
onBeforeUnmount(() => { document.documentElement.style.overflow = '' })
</script>
